import { styled, css } from 'styled-components';

export const Container = styled.main`
  left: 50%;
  max-width: 90%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 552px;
`;

export const Content = styled.div`
  ${({ theme: { fontSizes } }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    font-family: 'IBM Plex Sans';
    gap: 1.5rem;
    text-align: left;

    @media all and (max-width: 1024px) {
      h1 {
        font-size: ${fontSizes.s28};
      }
    }
  `}
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SignedInAsCard = styled.div`
  ${({ theme: { colors } }) => css`
    border: 1px solid ${colors.brandDarkAlpha10};
    border-radius: 8px;
    padding: 1rem 1.5rem;
  `}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
`;
